module.exports = __webpack_public_path__ + "static/media/piper-scheduler.e9ffe8c9.svg";